<template>
    <div
        class  ="nav-user-tab-item"
    >
        <f-title title="Unterschrift" />
        <f-image-upload
            :image = "signature"
            @drop  = "onDrop"
        />

        <div style="position: relative">
            <f-title title="Stempel" class="mt-5" />
            <div
                v-if="signature"
                class="lm-border  pl-1 pr-0 pb-0"
                style="position:absolute; left: 8px; bottom: 8px; width: 100px"
            >
                <v-slider
                    v-model="preferences.distanceSignature"
                    thumb-label
                    :thumb-size="24"
                    :ripple="false"
                    @change="onMoveSignature"
                    dense
                    hide-details
                />
             </div>
            <div class="stamp-panel lm-border mt-3 pa-3" style="height: 300px">
                <img
                    v-if = "stamp"
                    :src = "stamp"
                    alt  =""
                    style="max-width:100%; height:auto"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Msd          from "@/modules/msd/common/service/Msd";
import FImageUpload from "@/modules/core/components/utils/FImageUpload";
import FTitle       from "@/modules/core/components/utils/FTitle";

export default {
    name: "NavUserStamp",
    components: {
        FTitle,
        FImageUpload
    },

    data: () => ({
        drag: false,
        showMessage: false,
        message    : null,
        signature  : null,
        stamp      : null,
    }),

    computed: {
        preferences () {
            return this.$store.getters.preferences;
        },
    },

    mounted () {
        this.load();
    },

    methods: {
        load () {
            Msd.stamp.loadSignature(data => {
                this.signature = data;
                this.onMoveSignature();
            })
        },

        onDrop(file) {
            Msd.stamp.uploadSignature(file, data => {
                this.signature = data;
                this.onMoveSignature();
            }, (message) => {
                this.message = message;
                this.showMessage = true;
            });
        },

        onMoveSignature () {
            Msd.stamp.adjustSignature(this.preferences.distanceSignature, data => {
                this.stamp = data;
            }, (message) => {
                this.message = message;
                this.showMessage = true;
            });
        }
    }
}
</script>


<style scoped>

.stamp-panel {
    display: flex;
    justify-content: center;
    align-items: center;
}

</style>